import React from "react";

import * as go from 'gojs';
import { ReactDiagram } from 'gojs-react';

import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { Calendar } from 'primereact/calendar';

import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

class RiskListHeatmap extends React.Component {

	state = {

    };

    constructor(props) {
        super(props);
        this.makeHeatCubes()
        this.diagramRef = React.createRef();
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.aggregatedRisks && prevProps.aggregatedRisks !== this.props.aggregatedRisks) {
            if (this.props.aggregatedRisks.length > 0) {
                this.setHeatmapData();
            }
        } 
    }

    setHeatmapData() {
        const aggregate = this.props.aggregatedRisks;
        console.log(aggregate);

        if (!this.diagramRef.current) return;
        const diagram = this.diagramRef.current.getDiagram();

        var nodes = [...this.riskCubes];
        var links = [];

        for (var prob = 0; prob < aggregate.length; prob++) {
            for (var cons = 0; cons < aggregate[prob].length; cons++) {
                if (aggregate[prob][cons] > 0) { 
                    nodes.push({ key: "R" + prob + "C" + cons, category: "risk", loc: this.riskLocation(prob, cons), fill: "#FFFFFF", label: aggregate[prob][cons], value: aggregate[prob][cons] });
                }
            }
        }
        //nodes.push({ key: "R" + r, category: "risk", loc: this.riskLocation(1, 2), fill: "#FFFFFF", label: "bapp", value: 5 });
        
            console.log(nodes);
        diagram.model = new go.GraphLinksModel(nodes, links);
    }


    riskLocation(prob, cons) {
        const x = prob * 100 - 50;
        const y = (5 - cons) * 100 + 50;

        return '' + x + ', ' + y;
    }

    makeHeatCubes() {
        const cols = RiskLevels[0].length
        const rows = RiskLevels.length
        const numOfCubes = cols * rows;
        var riskCubes = [];
        for (let i = 0; i < numOfCubes; i++) {
            const x = Math.trunc(i / cols);
            const y = i - x * cols;
            const location = y*100 + ", " + (4-x)*100;
            
            riskCubes[i] = {
                key: i+'cube', category: "background", loc: location, fill: RiskLevels[x][y].bgColor, label: RiskLevels[x][y].label, value: RiskLevels[x][y].value };
        }
        this.riskCubes = riskCubes;
    }

    initDiagram() {
        const $ = go.GraphObject.make;

        go.Diagram.licenseKey = "73f944e0b16331b700ca0d2b113f69ed1bb37a669e821ff55e5941a1ef0068432b99ec7903d78e92d4ff5cec1c2990d1ddcc3a79c34b076be335dadb46e58ef1b63575e214584286a70576c19dfe7df4ff7976a7cabc25f0db78dff1efa0d18c5abda3d248985eba3b680530557eb04ab6e4da78";

        const diagram = $(go.Diagram,
            {
                initialPosition: new go.Point(0, 0),
                //isReadOnly: true, 
                initialContentAlignment: go.Spot.TopLeft,
                allowHorizontalScroll: false,
                allowVerticalScroll: false, 
                allowZoom: false,
                padding: 10,
            }

        );
      
        diagram.nodeTemplateMap.add("background",
            $(go.Node, "Auto",
                {
                    height: 100,
                    width: 100,
                    selectable: false,
                    layerName: "Background",
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Rectangle",
                    {
                        stroke: "white",
                        fill: "#FFE4A0",
                    },
                    new go.Binding("fill", "fill"),
                ),
                {
                toolTip:  // define a tooltip for each node that displays the color as text
                    $("ToolTip",
                        $(go.TextBlock, { margin: 4 },
                            new go.Binding("text", "label"))
                    )  // end of Adornment
                },
            )           
        );

        diagram.nodeTemplateMap.add("risk",
            $(go.Node, "Auto",
                {
                    locationSpot: go.Spot.Center,
                    height: 70,
                    width: 70,
                    selectable: false,
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Ellipse",
                    {
                        stroke: "white",
                        fill: "rgba(0, 0, 0, 0.5)",
                    },
                ),
                $(go.TextBlock,
                    {
                        font: "24pt sans-serif",
                        textAlign: "center",
                        stroke: "white",  
                        isMultiline: false,
                    },
                    new go.Binding("text", "label")
                )
            )
        );

        diagram.add( 
            $(go.Part, "Graduated",
                { layerName: "Grid", position: new go.Point(0, 500), graduatedMin: 0, graduatedMax: 500, graduatedTickUnit: 100 },
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 H500" }),
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 V10" }),
                $(go.TextBlock,
                    {
                        font: "9pt sans-serif",
                        alignmentFocus: new go.Spot(0, 0, -2, 0),
                        textAlign: "center",
                        stroke: "gray",
                        segmentOffset: new go.Point(7, 7),
                        graduatedFunction: function (v) {
                            return v > 400 ? null : ProbabilityLevels[Math.trunc(v / 100)].text;
                        }
                    }
                )
            ));


        diagram.add(
            $(go.Part, "Graduated",
                { layerName: "Foreground", position: new go.Point(-20, 0), graduatedMin: 0, graduatedMax: 500, graduatedTickUnit: 100 },
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 V500" }),
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 L0 10" }),
                $(go.TextBlock,
                    {
                        font: "9pt sans-serif",
                        alignmentFocus: new go.Spot(0, 0, -2, 0),
                        textAlign: "center",
                        stroke: "gray",
                        segmentOffset: new go.Point(7, 7),
                        angle:90,
                        graduatedFunction: function (v) {
                            return v > 400 ? null : ConsequenceLevels[4-Math.trunc(v / 100)].text;
                        }
                    }
                )
            ));

        diagram.model = new go.GraphLinksModel(this.riskCubes);

        diagram.addDiagramListener("ViewportBoundsChanged", (e) => {
            diagram.zoomToRect(diagram.documentBounds);
        });

        diagram.addDiagramListener('InitialLayoutCompleted', (e) => {
            diagram.zoomToRect(diagram.documentBounds); 
        });

        return diagram;
    }

    onDateChange(e) {
        var checkDate = new Date(e.value);
        checkDate.setDate(checkDate.getDate() + 1);
       
        var index = 0;
    }

	render() {

		return (
            <div style={{ padding: '0px', position: 'relative', aspectRatio: '1/1' }}> 
                <ReactDiagram
                    ref={this.diagramRef}
                    initDiagram={this.initDiagram.bind(this)}
                    divClassName='diagram-component'
                />
            </div>
		)
	}
}
export default RiskListHeatmap;